
<div class="padding-standard border-gray-top border-gray-bottom">
  <h6 class="mat-headline-5 ">
    {{'ss-process-wizard.actor.signature-config-title' | translate}}
  </h6>

</div>

<div class="padding-standard">
  <mat-accordion #accordion [multi]="true" >
  
    <mat-expansion-panel 
      [expanded]="(selectedSplugsSubject | async)[splugDefinition.id]"
      *ngFor="let splugDefinition of splugDefinitionsWithActionParamsObs | async;let idx=index"
      class="position-relative"
    >
    
      <mat-expansion-panel-header 
        [ngClass]="{
          'error-border':(errorSplugObs | async)[splugDefinition.id],
          'valid-border':(validSplugsObs | async)[splugDefinition.id]
        }"
        class="position-relative border-gray-bottom"
      >
      
        <mat-panel-title >
  
          <mat-checkbox 
            color="primary" 
            [checked]="(selectedSplugsSubject | async)[splugDefinition.id]"
            (change)="toggleSelectedSplug($event,splugDefinition.id)" (click)="$event.stopPropagation()">
          </mat-checkbox>
  
          <span class="mat-body-1">{{ splugDefinition.title }}</span>
        </mat-panel-title>
        <mat-panel-description class="mat-body-2">
          {{ splugDefinition.description }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <ss-actor-splug-form [splugDefinition]="splugDefinition"></ss-actor-splug-form>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  
</div>


  

